import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FileTypeIconPipe} from '../../pipes/file-type-icon.pipe'
import {Helpers} from "../helpers";
import {Document} from './index'

@Component({
  selector: 'document-list-item',
  standalone: true,
  imports: [CommonModule, FileTypeIconPipe],
  templateUrl: './document-list-item.component.html',
  styleUrls: ['./document-list-item.component.scss']
})
export class DocumentListItemComponent {

  id: string;

  @Input() document: Document | undefined;
  @Input() active: boolean;
  @Input() selected: boolean;
  @Output() change: EventEmitter<DocumentItemEvent> = new EventEmitter<DocumentItemEvent>()

  constructor() {
    this.id = Helpers.uuid();
    this.active ??= false;
    this.selected ??= false;
  }

  select() {
    this.change.emit({
      type: DocumentItemEventType.Selected,
      document: this.document!
    });
  }

  toggle() {
    this.change.emit({
      type: DocumentItemEventType.Toggled,
      document: this.document!
    });
  }
}

export interface DocumentItemEvent {
  type: DocumentItemEventType,
  document: Document,
}

export enum DocumentItemEventType {
  Toggled,
  Selected
}
